import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar, setCurrentModule, isCollapsed, setIsCollapsed }) => {
  const { logout, hasPermission, currentUser } = useAuth();
  const navigate = useNavigate();

  const allMenuItems = [
    { path: '/dashboard', icon: 'fa-chart-line', label: 'Dashboard', permission: 'dashboard_view' },
    { path: '/employee', icon: 'fa-users', label: 'Employee Management', permission: 'employee_view' },
    { path: '/leads', icon: 'fa-bullseye', label: 'Lead', permission: 'lead_view' },
    { path: '/attendance', icon: 'fa-calendar-check', label: 'Attendance', permission: 'attendance_view' },
    { path: '/leave', icon: 'fa-calendar-alt', label: 'Leave Management', permission: 'leave_view' },
    { path: '/payroll', icon: 'fa-money-bill-wave', label: 'Payroll', permission: 'payroll_view' },
    { path: '/task', icon: 'fa-tasks', label: 'Task Management', permission: 'task_view' },
    { path: '/performance', icon: 'fa-star', label: 'Performance', permission: 'performance_view' },
    { path: '/document', icon: 'fa-file-alt', label: 'Documents', permission: 'document_view' },
    { path: '/asset', icon: 'fa-box', label: 'Asset Management', permission: 'asset_view' },
    { path: '/daily-report', icon: 'fa-file-alt', label: 'Daily Report', permission: 'report_view' },
    { path: '/roles', icon: 'fa-user-shield', label: 'Role Management', permission: 'role_manage' },
    { path: '/admin', icon: 'fa-cog', label: 'Admin Panel', permission: 'all' }
  ];

  // Filter menu items based on user permissions
  let menuItems = allMenuItems.filter(item => {
    if (item.label === 'Payroll' && currentUser?.role === 'employee') {
      return true;
    }
    return hasPermission(item.permission);
  });

  // If user is a regular employee, only show requested items in drawer
  if (currentUser?.role === 'employee') {
    const allowedLabels = ['Dashboard', 'Lead', 'Attendance', 'Leave Management', 'Payroll', 'Task Management', 'Documents', 'Daily Report'];
    menuItems = menuItems.filter(item => allowedLabels.includes(item.label));
  }

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'} ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="logo">
        <i className="fas fa-briefcase"></i>
        {!isCollapsed && <h2>Employee CRM</h2>}
      </div>
      <button className="hamburger-toggle" onClick={toggleCollapse} title={isCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}>
        <i className={`fas ${isCollapsed ? 'fa-bars' : 'fa-chevron-left'}`}></i>
      </button>
      <nav className="nav-menu">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={() => {
              setCurrentModule(item.label);
              if (window.innerWidth <= 1024) {
                toggleSidebar();
              }
            }}
            title={isCollapsed ? item.label : ''}
          >
            <i className={`fas ${item.icon}`}></i>
            {!isCollapsed && <span>{item.label}</span>}
          </NavLink>
        ))}
      </nav>
      <div className="sidebar-footer">
        <button
          type="button"
          className="logout-button"
          onClick={handleLogout}
          title={isCollapsed ? 'Logout' : ''}
        >
          <i className="fas fa-sign-out-alt"></i>
          {!isCollapsed && <span>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
